module.exports = __webpack_public_path__ + "img/responsabilidad-colegio-loyola.d56be7cd.png";